import React from "react";
import "./style.css";
import { useParams } from "react-router-dom";

const BatchEdit = () => {
  const { beid } = useParams();

  return (
    <div className="page-content">
      <h1>Hello world {beid}</h1>
    </div>
  );
};
export default BatchEdit;
